// extracted by mini-css-extract-plugin
export default {"loginMessage":"DocumentsSideBar_loginMessage__COdP+"};